import * as React from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ExpensesNav(props){

    return(
      <Box
            sx={{
            display: 'flex',
            justifyContent: 'space-between',
            columnGap: 1
            }}
      >
        <Box>
          <Link to="..">
            <Button
              sx={{ mr: "auto" }}
              color="success"
              variant="outlined"
              size="small" 
            >
              Back
            </Button>
          </Link>
        </Box>
      </Box>
    )

}